import BasePage from "components/basePage/BasePage";
import Button from "components/button/Button";
import NewPasswordInputs from "components/input/NewPasswordInputs";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getParameterFromURL, showToast } from "services/helper";
import { resetPassword } from "services/requests";
import "./RecoveryPassword.scss";

export function RecoveryPassword() {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const token = getParameterFromURL("token");

  function onSubmit(event) {
    event?.preventDefault();
    const noErrorFound =
      newPassword === confirmPassword &&
      newPassword.length > 0 &&
      confirmPassword.length > 0;

    if (noErrorFound) {
      setLoading(true);
      resetPassword({ token: token, newPassword: newPassword })
        .then(() => {
          showToast("Sua senha foi alterada com sucesso!", "success");
          navigate("/login");
        })
        .catch(() => {
          showToast(
            "Não foi possível alterar sua senha, tente novamente mais tarde.",
            "error"
          );
        });
    }
  }

  return (
    <BasePage title="Redefinição de Senha">
      <form id="new-password-form">
        <NewPasswordInputs
          newPassword={newPassword}
          setNewPassword={setNewPassword}
          confirmPassword={confirmPassword}
          setConfirmPassword={setConfirmPassword}
        />
        <Button
          text="Salvar"
          className="save-button"
          loading={loading}
          onClick={onSubmit}
        />
      </form>
    </BasePage>
  );
}
